import React from "react";
import styled, { css } from "styled-components";
import { HeaderLinkTag, HeaderTag } from "../containers/Header";

const AccordionItem = styled.div``;

const AccordionTitleContainer = styled.div`
  display: flex;
  width: ${(props) => (props.isHeader ? "0px" : "100%")};
  border-bottom: 1px solid #424242;
  justify-content: space-between;
  align-items: center;
  img {
    ${(props) => !props.isHeader && `filter: invert(0.5)`};
    transform: rotate(0deg);
    transition: all 0.3s ease-in-out;
    ${({ active }) =>
      active
        ? css`
            transform: rotate(180deg);
          `
        : css`
            transform: rotate(0deg);
          `}
  }
`;

const AccordionTitle = styled.h2`
  color: #f86a6e;
  font-family: "Lato";
  font-size: 20px;
  margin-bottom: 25px;
  color: ${({ active }) => (active ? "#f86a6e" : "#afafaf")};
  cursor: pointer;
`;

const AccordionLink = styled.a`
  text-decoration: none;
  color: #afafaf;
  transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
  margin: 10px 0px;
  &:hover {
    color: #fff;
    padding-left: 10px;
  }
`;

const AccordionBody = styled.div`
  display: block;
  position: relative;
  padding: 0;
  margin: 0;
  height: 0;
  overflow: hidden;
  transition: height 0.3s;

  ${({ active, bodyHeight }) =>
    active &&
    css`
      height: ${bodyHeight}px;
    `}
`;

const AccordionContent = styled.div`
  margin: ${(props) => (props.isHeader ? "10px 20px" : 0)};
  height: auto;
`;

const AccordionContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 250px;
  @media (max-width: 840px) {
    min-width: 215px;
  }
  @media (max-width: 425px) {
    min-width: 100%;
  }
`;

const HeaderTagContent = styled.p`
  font-size: 15px;
  font-family: "Lato";
  margin: 0px;
  color: #2d2d2d;
  text-decoration: none;
`;

const BASE_PATH = process.env.BASE_PATH;

function Accordion({
  accordionContent,
  refs,
  currentAccordion,
  setCurrentAccordion,
  setBodyHeight,
  bodyHeight,
  isHeader,
}) {
  return accordionContent.map(({ title, content }, i) => (
    <AccordionItem key={`accordion-item-${i}`}>
      <AccordionTitleContainer
        onClick={() => {
          if (currentAccordion === i) {
            setCurrentAccordion();
          } else {
            setCurrentAccordion(i);
          }
          setBodyHeight(refs[i].current.clientHeight);
        }}
        active={currentAccordion === i}
        isHeader={isHeader}
      >
        {isHeader ? (
          title === "Picmaker Social" ? (
            <HeaderTag>
              <HeaderLinkTag>
                Picmaker Social
                <span className="coming-soon">New</span>
              </HeaderLinkTag>
            </HeaderTag>
          ) : (
            <HeaderTagContent>{title}</HeaderTagContent>
          )
        ) : (
          <AccordionTitle active={currentAccordion === i}>
            {title}
          </AccordionTitle>
        )}
        <img
          src={`${BASE_PATH}/images/icon-down-arrow.svg`}
          width={isHeader ? "12px" : "14px"}
          height={isHeader ? "12px" : "14px"}
          alt="icon-arrow"
          title="icon-arrow"
        />
      </AccordionTitleContainer>
      <AccordionBody active={currentAccordion === i} bodyHeight={bodyHeight}>
        <AccordionContent ref={refs[i]} isHeader={isHeader}>
          {content.map((data, index) => (
            <AccordionContentWrapper key={index}>
              <AccordionLink href={data.link}>{data.title}</AccordionLink>
            </AccordionContentWrapper>
          ))}
        </AccordionContent>
      </AccordionBody>
    </AccordionItem>
  ));
}

export default Accordion;
